import { env } from '@/env';

type RetailerAvatarProps = {
  id: string;
  name: string;
  sizeClass?: string; // e.g. "w-4-0 h-4-0" or "w-3-2 h-3-2"
  className?: string;
};

const RetailerAvatar: React.FC<RetailerAvatarProps> = ({
  id,
  name,
  sizeClass = 'w-3-2 h-3-2',
  className,
}) => {
  return (
    <div
      className={`${sizeClass} bg-secondary-grey rounded-full flex items-center justify-center overflow-hidden ${
        className ?? ''
      }`.trim()}
    >
      <img
        className="object-contain w-full h-full"
        src={`${env.VITE_STATIC_URL}/retailer/images/${id}-logo.png`}
        alt={name}
        loading="lazy"
      />
    </div>
  );
};

export default RetailerAvatar;
